/**
 * Cancela peticiones GET en vuelo al cambiar de ruta.
 *
 * Las peticiones GET de pantallas anteriores (listas grandes como
 * Persons/GetAllPersonsFiltered) pueden seguir 15-30s tras navegar a otra
 * pantalla. Permanecen en $http.pendingRequests y mantienen visible el
 * loader global sobre una pantalla ya renderizada.
 *
 * Solución: el interceptor consulta este servicio para obtener una promesa
 * `timeout` que AngularJS resuelve como cancelación. Cuando se dispara
 * $stateChangeStart, resolvemos esa promesa y creamos otra para la
 * siguiente pantalla.
 *
 * AB#2897
 */
angular.module("app")
    .factory('requestCancellationService', ['$q', '$rootScope', function ($q, $rootScope) {
        let currentDeferred = $q.defer();

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
            // Solo cancelar si realmente estamos cambiando de pantalla.
            // Cambios de parámetros sobre el mismo state los respeta el ui-router
            // (notify=false con reload=false) pero por seguridad solo cancelamos
            // si el name del state cambió.
            if (fromState && toState && fromState.name && fromState.name !== toState.name) {
                currentDeferred.resolve();
                currentDeferred = $q.defer();
            }
        });

        return {
            /** Promesa que AngularJS resuelve como cancelación del request. */
            getTimeoutPromise: function () {
                return currentDeferred.promise;
            },
        };
    }]);
